import FormViewForm from '@src/components/_forms/FormViewForm';
import PurchaseMaterialsField from './fields/PurchaseMaterialsField';
import {IPurchaseModel} from '@src/@interfaces/models/Purchase/IPurchaseModel';

const customFields = {
    materials: {
        component: PurchaseMaterialsField,
    },
};

export default class PurchaseForm<Model extends IPurchaseModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'materials') {
            return this.getMaterialsFieldInitialValue();
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    private getMaterialsFieldInitialValue() {
        return this.props.model?.materials?.map(item => ({
            id: item.id,
            material_id: item.material_id,
            price: item.price ? item.price / 100 : 0, // TODO
            quantity: item.quantity ? item.quantity / 10000 : 0, // TODO
        }));
    }
}
